export const PROGRAM_LIST = [
  {
    id: "greetings",
    lecture: "あいさつ",
    time: "13:10～13:15",
    title: "",
    speaker: "吉田 厚",
    company: "音羽電機工業株式会社　代表取締役社長",
    overview: "",
    biography: "",
  },
  {
    id: "lecture01",
    lecture: "特別講演",
    time: "13:15～14:00",
    title: "「EMP（電磁パルス）の脅威とその対策について」",
    speaker: "渡辺 秀明",
    company: "防衛技術協会理事長（初代防衛装備庁長官）",
    overview:
      "現代戦において、EMP（電磁パルス）は、防衛施設や重要インフラ等への重大な脅威であり、その対策は喫緊の課題です。その対策技術は、音羽電機工業の雷対策技術の延長上に有力な解があると考えます。\n音羽電機工業は、防衛装備庁の大型研究に採択され、独自のEMP発生装置で脅威の再現（攻撃模擬）と防御性能の双方を実証できる会社です。理論だけではなく、確かな検証データに裏打ちされたこの国産技術が、我が国の安全保障基盤を真に強靭化すると考えています。",
    biography:
      "<dl><dt>1979年3月</dt><dd>慶應義塾大学大学院理工学研究科修士課程修了</dd></dl><dl><dt>1979年4月</dt><dd>防衛庁技術研究本部　第1研究所　レーダー研究室</dd></dl><dl><dt>1987年3月</dt><dd>工学博士（慶應義塾大学）</dd></dl><dl><dt>2009年4月</dt><dd>防衛省技術研究本部 総務部長</dd></dl><dl><dt>2011年8月</dt><dd>防衛省大臣官房技術監</dd></dl><dl><dt>2013年9月</dt><dd>防衛省技術研究本部長</dd></dl><dl><dt>2015年10月</dt><dd>防衛装備庁長官（初代）</dd></dl><dl><dt>2017年 7月</dt><dd>防衛省退官</dd></dl><dl><dt>2018年8月</dt><dd>SBIホールディングス株式会社 顧問</dd></dl><dl><dt>2022年8月</dt><dd>一般財団法人防衛技術協会理事長</dd></dl><dl><dt>2025年7月</dt><dd>JADC顧問（SHIFT社）</dd></dl>",
  },
  {
    id: "lecture02",
    lecture: <>講演&thinsp;1</>,
    time: "14:00～14:45",
    title: "「雷から反粒子!?--シチズンサイエンスで挑む雷の科学と文化」",
    speaker: "榎戸 輝揚",
    company: "京都大学 理学研究科 准教授",
    overview:
      "身近な現象である雷や雷雲は、実は光速に近い電子が飛び交う「天然の加速器」であり、雷雲から地上に降り注ぐガンマ線や、雷によって生み出される反粒子（陽電子）といった驚くべき現象が、近年の研究で明らかになりました。これらを調べる市民科学「雷雲プロジェクト」を通じ、冬の雷を地域の文化資源として捉え直す挑戦についてお話しします。",
    biography:
      "<dl><dt>2010年</dt><dd>東京大学大学院理学系研究科物理学専攻博士課程修了（博士・理学）<br/>スタンフォード大学、NASAゴダード宇宙飛行センターでの研究や、京都大学白眉センター特定准教授、理化学研究所白眉研究チームリーダーを経る</dd></dl><dl><dt>2017年</dt><dd>「Physics World Top 10 Breakthrough 2017」</dd></dl><dl><dt>2019年</dt><dd>「文部科学大臣表彰 若手科学者賞」等を受賞</dd></dl><dl><dt>2022年11月</dt><dd>京都大学大学院理学研究科准教授<br/>専門は中性子星の研究を中心とした高エネルギー宇宙物理学（X線・ガンマ線天文学）、および雷や雷雲からの放射線を対象とする高エネルギー大気物理学</dd></dl>",
  },
  {
    id: "break",
    lecture: "休憩",
    time: "14:45～15:00",
    title: "",
    speaker: "",
    company: "",
    overview: "",
    biography: "",
  },
  {
    id: "lecture03",
    lecture: <>講演&thinsp;2</>,
    time: "15:00～15:45",
    title: "「外部雷保護の基本とJIS規格改定について」",
    speaker: "舟崎 博志",
    company: "NIPエンジニアリング株式会社 技術部 部長",
    overview:
      "建物を雷から守る外部雷保護設備について、その基本的な考え方に触れながら、JIS規格の改定による変更点やその影響について解説いたします。\n建物の側面に落ちる雷への対策として設ける受雷部等の高層建築物で考慮しておくべき点や、プレキャストコンクリート構造の建築物における注意点など、建物の計画段階から考えておきたい雷保護設備についても説明いたします。",
    biography: "",
  },

  {
    id: "lecture04",
    lecture: <>講演&thinsp;3</>,
    time: "15:45～16:30",
    title: "「電気・電子システムの雷保護基本とリスク管理」",
    speaker: "小玉 鉄晃",
    company: "音羽電機工業株式会社　エンジニアリング事業部　雷コンサルティング部　次長",
    overview:
      "雷が増加傾向にある中、ひとたび落雷があれば建物内の電気・電子システムにも雷被害が発生します。\n情報社会である現代において、情報設備に雷被害が発生することは企業資産を失うことと同義です。\n本講演では、雷から設備を雷保護するために、雷害対策の基本的な考え方について雷被害事例を交えながらお話しします。",
    biography: "",
  },
];
